import { createSafetyProgramRepository } from './repository';
import type { ActivityIndexReader } from '../briefing/activity-index-port';

export const safetyProgramActivityReader: ActivityIndexReader = {
  async load(scope) {
    const value=await createSafetyProgramRepository(scope.siteId).summary(scope.year);
    const summary=value.summary;
    if(summary.annualTarget===null) return {...scope,state:'unconfigured',annualTarget:null,completed:null};
    if(!summary.complete || summary.actual===null) return {...scope,state:'incomplete',annualTarget:summary.annualTarget,completed:null};
    return {...scope,state:'ready',annualTarget:summary.annualTarget,completed:summary.actual};
  },
};

/** Reminder date is derived, never stored as another independent calendar event. */
export function inspectionReminderDate(dueDate:string) {
  const date=new Date(`${dueDate}T00:00:00Z`);
  if(!Number.isFinite(date.getTime())||date.toISOString().slice(0,10)!==dueDate)throw Error('INSPECTION_DATE_INVALID');
  date.setUTCDate(date.getUTCDate()-30);
  return date.toISOString().slice(0,10);
}
